
import {
    PublicClientApplication,
  } from "@azure/msal-browser";

const APP_CONTEXT_KEY = "dbsActiveAppContext";
const MAIN_APP_CONTEXT = "main-app";

const hasPendingAuthResponse = () => {
  /* istanbul ignore next -- SSR guard, unreachable in browser/jsdom */
  if (typeof window === "undefined") {
    return false;
  }
  const { search = "", hash = "" } = window.location;
  const authResponsePattern = /(?:^|[?#&])(code|state|error|error_description)=/i;
  return authResponsePattern.test(search) || authResponsePattern.test(hash);
};

const syncAppSessionContext = () => {
  /* istanbul ignore next -- SSR guard, unreachable in browser/jsdom */
  if (typeof window === "undefined") {
    return;
  }
  const activeContext = window.sessionStorage.getItem(APP_CONTEXT_KEY);
  if (
    activeContext &&
    activeContext !== MAIN_APP_CONTEXT &&
    !hasPendingAuthResponse()
  ) {
    window.sessionStorage.clear();
  }
  window.sessionStorage.setItem(APP_CONTEXT_KEY, MAIN_APP_CONTEXT);
};

syncAppSessionContext();

export const MSAL_CONFIG = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: `${process.env.REACT_APP_AUTHORITY}/${process.env.REACT_APP_TENANT_ID}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri:window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

export const msalInstance = new PublicClientApplication(MSAL_CONFIG);